<h4 *ngIf="!showForm">Common elements condo details</h4>

<app-container
	*ngIf="!showForm"
	[@openClose]
	class="mt-2"
	[testHook]="testHooks.Container"
>
	<div class="mt-4">
		<div class="flex justify-between">
			<app-pill mode="secondary" [testHook]="testHooks.Pill">{{
				propertyType.condoPlan
			}}</app-pill>

			<app-icon
				[icon]="ICON.EDIT"
				(click)="showFormToggle()"
				class="cursor-pointer"
				[testHook]="testHooks.EditIcon"
			></app-icon>
		</div>

		<hr class="my-4" />

		<div class="flex justify-between">
			<div>
				<label class="font-bold text-lg">Interest</label>
				<span class="ml-2 text-lg">{{
					propertyType.percentageInterest / 100 | percent: '1.0-4'
				}}</span>
			</div>
			<div>
				<label class="font-bold text-lg">Common expenses</label>
				<span class="ml-2 text-lg">{{
					propertyType.commonExpenses | centsToDollars
				}}</span>
			</div>
		</div>
	</div>
</app-container>

<app-parcel-of-tied-land-form
	*ngIf="showForm"
	[@openClose]
	(onFormSubmit)="onFormSubmit()"
	(onCancel)="onFormCancel()"
></app-parcel-of-tied-land-form>
